import React from 'react';
import { IconBase } from '../Base';
export const IconCode = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("g", { style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("path", { d: "M6 7L3 10L6 13" }),
            React.createElement("path", { d: "M14 7L17 10L14 13" }),
            React.createElement("path", { d: "M12.5 4.5L7.5 15.5" }))));
};
//# sourceMappingURL=Code.js.map